import { render, staticRenderFns } from "./MedicalView.vue?vue&type=template&id=688e3366&"
import script from "./MedicalView.vue?vue&type=script&lang=js&"
export * from "./MedicalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports